import { truncate } from "infrastructure/utils/truncate"
import { useTranslate } from "infrastructure/hooks/useTranslate"

import { renderDatetimeCell } from "domain/core/utils"

import { CopiedField } from "view/components/CopiedField"

import * as S from "./styled"

const prefixLocale = "pages.transactions.grid"

export const columnsConfig = () => [
  {
    field: "startedAt",
    headerName: useTranslate(`${prefixLocale}.startedAt`),
    width: 160,
    renderCell: renderDatetimeCell,
  },
  {
    field: "finalAt",
    headerName: useTranslate(`${prefixLocale}.finalAt`),
    width: 160,
    renderCell: renderDatetimeCell,
  },
  {
    field: "operation",
    headerName: useTranslate(`${prefixLocale}.operation`),
    sortable: false,
    width: 140,
    renderCell: ({ value }) => (
      <S.OperationWrapper status={value}>{value}</S.OperationWrapper>
    ),
  },
  {
    field: "orderId",
    headerName: useTranslate(`${prefixLocale}.orderId`),
    sortable: false,
    width: 140,
    renderCell: ({ value, row }) => (
      <CopiedField
        value={value}
        Component={
          <S.Action title={value} to={`/finance/transactions/${row.id}`}>
            {truncate(value) || "No order ID"}
          </S.Action>
        }
      />
    ),
  },
  {
    field: "status",
    headerName: useTranslate(`${prefixLocale}.status`),
    sortable: false,
    width: 160,
    renderCell: ({ value }) => (
      <S.ActionWrapper status={value}>
        {value.replace(/_/, " ")}
      </S.ActionWrapper>
    ),
  },
  {
    field: "externalId",
    headerName: useTranslate(`${prefixLocale}.externalId`),
    sortable: false,
    width: 140,
    renderCell: ({ value }) => {
      if (value !== "—") return <CopiedField value={value} truncate />
      return value
    },
  },
  {
    field: "paymentSystemOrderId",
    headerName: useTranslate(`${prefixLocale}.paymentSystemOrderId`),
    sortable: false,
    width: 200,
    renderCell: ({ value }) => {
      if (value !== "—") return <CopiedField value={value} truncate />
      return value
    },
  },
  {
    field: "customerId",
    headerName: useTranslate(`${prefixLocale}.customerId`),
    sortable: false,
    width: 140,
    renderCell: ({ value }) => <CopiedField value={value} truncate />,
  },
  {
    field: "customerEmail",
    headerName: useTranslate(`${prefixLocale}.customerEmail`),
    sortable: false,
    width: 200,
    renderCell: ({ value }) => <CopiedField value={value} />,
  },
  {
    field: "country",
    headerName: useTranslate(`${prefixLocale}.country`),
    sortable: false,
    width: 80,
  },
  {
    field: "paymentMethodIn",
    headerName: useTranslate(`${prefixLocale}.paymentMethodIn`),
    sortable: false,
    width: 140,
  },
  {
    field: "cardBrand",
    headerName: useTranslate(`${prefixLocale}.cardMethod`),
    sortable: false,
    width: 140,
  },
  {
    field: "cardMaskedPan",
    headerName: useTranslate(`${prefixLocale}.cardPan`),
    sortable: false,
    width: 140,
  },
  {
    field: "cardIssuingCountry",
    headerName: useTranslate(`${prefixLocale}.cardCountry`),
    sortable: false,
    width: 140,
  },
  {
    field: "fullName",
    headerName: useTranslate(`${prefixLocale}.fullName`),
    sortable: false,
    width: 140,
  },
  {
    field: "countryOfResidence",
    headerName: useTranslate(`${prefixLocale}.countryOfResidence`),
    sortable: false,
    width: 140,
  },
  {
    field: "paymentMethodOut",
    headerName: useTranslate(`${prefixLocale}.paymentMethodOut`),
    sortable: false,
    width: 100,
  },
  {
    field: "failReason",
    headerName: useTranslate(`${prefixLocale}.failReason`),
    sortable: false,
    width: 200,
    renderCell: ({ value }) => {
      if (value !== "—") return <CopiedField value={value} />
      return value
    },
  },
  {
    field: "clientPayAmount",
    headerName: useTranslate(`${prefixLocale}.clientPayAmount`),
    sortable: false,
    width: 140,
  },
  {
    field: "clientPayCurrency",
    headerName: useTranslate(`${prefixLocale}.clientPayCurrency`),
    sortable: false,
    width: 200,
  },
  {
    field: "clientGetAmount",
    headerName: useTranslate(`${prefixLocale}.clientGetAmount`),
    sortable: false,
    width: 140,
  },
  {
    field: "clientGetCurrency",
    headerName: useTranslate(`${prefixLocale}.clientGetCurrency`),
    sortable: false,
    width: 200,
  },
  {
    field: "clientPaySystemAmount",
    headerName: useTranslate(`${prefixLocale}.clientPaySystemAmount`),
    width: 200,
  },
  {
    field: "clientPaySystemCurrency",
    headerName: useTranslate(`${prefixLocale}.clientPaySystemCurrency`),
    sortable: false,
    width: 240,
  },
  {
    field: "merchantPnl",
    headerName: useTranslate(`${prefixLocale}.merchantPnl`),
    sortable: false,
    width: 100,
  },
  {
    field: "merchantPnlSystem",
    headerName: useTranslate(`${prefixLocale}.merchantPnlSystem`),
    sortable: false,
    width: 100,
  },
]
